module.exports = " <div class=row _v-74f71678=\"\"> <silver-sponsor v-for=\"sponsor in sponsorRow\" :sponsor=sponsor :conf=conf _v-74f71678=\"\"></silver-sponsor> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-74f71678!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SilverSponsorRow.vue
 ** module id = 68
 ** module chunks = 1
 **/